import type React from 'react';

import styles from './BlurCircle.module.scss';

interface BlurCircleProps {
  className?: string; // Allow passing additional classes for positioning
}

const BlurCircle: React.FC<BlurCircleProps> = ({className}) => {
  return <div className={`${styles.circle} ${className || ''}`} />;
};

export default BlurCircle;
